import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'feedback', 'pairing', 'plate'];

  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  get choiceFeedback() {
    return this.element.querySelector(`#${event.params.feedback}`);
  }

  get isChoiceCorrect() {
    return this.choiceFeedback.classList.contains('correct');
  }

  choose(event) {
    this.markChoiceSelected(event.currentTarget);
    this.copyPairingImage(event.currentTarget);
    this.copyPlateImage(event.currentTarget);
    this.displayFeedback();

    if (this.isChoiceCorrect) {
      this.enableNextNavigation();
    }
  }

  markChoiceSelected(pressedButton) {
    this.buttonTargets.forEach((button) => {
      button.classList.remove('selected');
    });
    pressedButton.classList.add('selected');
  }

  copyPairingImage(pressedButton) {
    if (this.hasPairingTarget && pressedButton.classList.contains('correct')) {
      this.pairingTarget.innerHTML = pressedButton.innerHTML;
    }
  }

  copyPlateImage(pressedButton) {
    if (this.hasPlateTarget) {
      this.plateTarget.innerHTML = pressedButton.querySelector('.plate').outerHTML;
      this.plateTarget.querySelector('.plate').classList.remove('display-none');
    }
  }

  displayFeedback() {
    this.feedbackTargets.forEach((feedback) => {
      feedback.classList.add('display-none');
    });
    this.choiceFeedback.classList.remove('display-none');
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
